import { render, staticRenderFns } from "./ReservasPrincipal.vue?vue&type=template&id=39ebf851&scoped=true&"
import script from "./ReservasPrincipal.vue?vue&type=script&lang=js&"
export * from "./ReservasPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ebf851",
  null
  
)

export default component.exports